import ApiService from 'Services/ApiService'

export default {
    list(visitId, type) {
        return ApiService.get(`attachments/${visitId}/${type}`)
    },
    download(visitId, type, id) {
        return ApiService.download(`attachments/${visitId}/${type}/${id}`)
    },
    upload(visitId, type, data) {
        return ApiService.upload(`attachments/${visitId}/${type}`, data.data, data.onProgress)
    },
    delete(visitId, type, id) {
        return ApiService.delete(`attachments/${visitId}/${type}/${id}`)
    },
}